export default __webpack_public_path__ + "static/media/COW_NOISE.90e5805a.wav";